import React from 'react'
import { Card } from '../../../atoms'

interface Ilinks {
  linkTitle: string
  linkUrl: string
}

type LinkDetails = {
  sectionTitle: string
  links: Ilinks[]
}

interface ILinkCollectionJsonBody {
  title: string
  linkDetails: LinkDetails[]
}

interface ILinkCollectionProps {
  jsonBody: ILinkCollectionJsonBody
  name: string
  variant: string
  rawName: string
  sys: { id: string }
  showHeader: boolean
}

const LinkCollection: React.FC<ILinkCollectionProps> = ({
  jsonBody,
  name,
  variant,
  rawName,
  sys,
  showHeader,
}: ILinkCollectionProps): React.ReactElement<ILinkCollectionProps> => {
  const { title, linkDetails } = jsonBody

  const linksSection = (links: Ilinks[]) =>
    links.map(({ linkTitle, linkUrl }, index) => (
      <span key={index} className='LinkCollection__LinksSectionLink'>
        <a
          href={linkUrl}
          /* eslint-disable camelcase */
          data-click-tracking={JSON.stringify({
            component_category: 'platinum-component',
            component_id: sys?.id,
            component_name: 'LinkCollection',
            contentful_name: rawName,
            contentful_variant: variant,
            additionalProps: { text: linkTitle, linkUrl },
          })}
        >
          {linkTitle}
        </a>
      </span>
    ))

  try {
    return (
      <div className='LinkCollection' id={name}>
        {showHeader && <h2 className='LinkCollection__title'>{title}</h2>}
        <div className='LinkCollection__LinksSections'>
          {linkDetails.map(({ links, sectionTitle }, i) => (
            <div className='LinkCollection__LinksSection' key={i}>
              <Card variant={i % 2 === 0 ? 'linkCollectionPrimary' : 'linkCollectionSecondary'}>
                <p
                  className={
                    i % 2 === 0
                      ? 'LinkCollection__LinksSectionTitlePrimary'
                      : 'LinkCollection__LinksSectionTitleSecondary'
                  }
                >
                  {sectionTitle}
                </p>
                <div
                  className={
                    i % 2 === 0
                      ? 'LinkCollection__LinksSectionLinksPrimary'
                      : 'LinkCollection__LinksSectionLinksSecondary'
                  }
                >
                  {linksSection(links)}
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default LinkCollection
